import {
  AdminPanelSettings as AdminPanelSettingsIcon,
  Groups2Rounded as GroupsIcon,
  People as PeopleIcon,
} from '@mui/icons-material';
import type { NavItemType } from '../types/menu';

const icons = {
  management: GroupsIcon,
  users: PeopleIcon,
  roles: AdminPanelSettingsIcon,
};

const management: NavItemType = {
  id: 'group-management',
  title: 'Management',
  type: 'group',
  icon: icons.management,
  children: [
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.users,
      permissionModule: 'users',
    },
    {
      id: 'staff',
      title: 'Staff',
      type: 'item',
      url: '/staff',
      icon: icons.management,
      permissionModule: 'staff',
    },
    {
      id: 'role',
      title: 'Role',
      type: 'item',
      url: '/role',
      icon: icons.roles,
      permissionModule: 'roles',
    }
  ],
};

export default management;
